/// <amd-module name="Wit/BoardsHub/KanbanBoard/Utils/BoardUtils" />
import { BoardColumn, BoardColumnType } from "Wit/BoardsHub/Common/Client/Contracts/Settings";
import { BoardColumnLayout } from "Wit/BoardsHub/Common/KanbanBoardContracts";

export function isOutgoing(column?: BoardColumn): boolean {
    return column?.columnType === BoardColumnType.Outgoing;
}

export function isIncoming(column?: BoardColumn): boolean {
    return column?.columnType === BoardColumnType.Incoming;
}

export function isInProgress(column?: BoardColumn): boolean {
    return column?.columnType === BoardColumnType.InProgress;
}

export function hasItems(column?: BoardColumnLayout, filteredIds?: Set<number>): boolean {
    const columnHasSomeWorkItems = !!column && column.workItems.length > 0;
    const filteredWorkItemsExist = filteredIds && filteredIds.size;
    if (columnHasSomeWorkItems && filteredWorkItemsExist) {
        const columnHasFilteredWorkItems = column.workItems.value.filter(workItem => filteredIds.has(workItem.value.id)).length > 0;
        return columnHasFilteredWorkItems;
    }

    return columnHasSomeWorkItems;
}

export function hasItem(column?: BoardColumnLayout, itemId?: number): boolean {
    return !!column?.workItems.value.find(item => item.value.id === itemId);
}

/**
 * Try to focus a card given the id of a work item on the board
 * @returns true on success
 */
export function focusCard(itemId: number): boolean {
    const cardElement = document.querySelector(`.wit-card[data-itemid="${itemId}"]`) as HTMLElement | null;
    if (cardElement) {
        cardElement.focus();
        return true;
    }

    return false;
}
